
import Vue from "vue";

import { css, StyleSheet } from "aphrodite";

export default {
	install(Vue, options = {}) {
		Vue.prototype.$css = css;
		Vue.prototype.$style = StyleSheet.create.bind(StyleSheet);
	}
}
